import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useDisclosure, Button, Image } from '@chakra-ui/react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay, Thumbs } from 'swiper/modules'
import React from 'react'

export function ModalImagensProduct({ images }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null)

  images = images.slice(1)

  console.log(thumbsSwiper)

  return (
    <>
      <Button size="xs" variant="link" onClick={onOpen}>
        Ver mais
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{thumbsSwiper && thumbsSwiper.slides.length} Imagens</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay, Thumbs]}
              spaceBetween={10}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              effect="fade"
              autoplay={{ delay: 5000 }}
              thumbs={{ swiper: thumbsSwiper }}
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <Image src={image} alt="Product" mx="auto" />
                </SwiperSlide>
              ))}
            </Swiper>
            <Swiper
              id="thumbs"
              onSwiper={setThumbsSwiper}
              spaceBetween={10}
              slidesPerView={3}
              freeMode={true}
              watchSlidesVisibility
              watchSlidesProgress
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <Image src={image} alt="Product" mx="auto" />
                </SwiperSlide>
              ))}
            </Swiper>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
